import { ErrorUtils } from '../utils/siteUtils'

// check - a function that should return false or true
// onComplete - a function to execute when the check function returns true
// delay - time in milliseconds, specifies the time period between each check. default value is 100
// timeout - time in milliseconds, specifies how long to wait and check the check function before giving up
const waitUntil = (check, onComplete, delay, timeout) => {
  // if the check returns true, execute onComplete immediately
  if (check()) {
    onComplete()
    return
  }

  if (!delay) delay = 100

  let timeoutPointer
  let intervalPointer = setInterval(function() {
    if (!check()) return // if check didn't return true, means we need another check in the next interval

    // if the check returned true, means we're done here. clear the interval and the timeout and execute onComplete
    clearInterval(intervalPointer)
    if (timeoutPointer) clearTimeout(timeoutPointer)
    onComplete()
  }, delay)

  // if after timeout milliseconds function doesn't return true, abort
  if (timeout)
    timeoutPointer = setTimeout(function() {
      clearInterval(intervalPointer)
    }, timeout)
}

const fireDocumentEvent = event => {
  let eventObj

  // Cross browser handling
  if (typeof Event === 'function') {
    eventObj = new CustomEvent(event)
  } else {
    eventObj = document.createEvent('Event')
    eventObj.initEvent(event, false, false)
  }

  document.body.dispatchEvent(eventObj)
}

const createGuid = () => {
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

  return guid
}

const addScript = (src, location, forceInclude) => {
  try {
    const scriptExists = document.querySelector('script[src*="' + src + '"]')

    if (!scriptExists || forceInclude) {
      const appendTo = location || document.getElementsByTagName('script')[0].parentNode
      const scriptContainer = document.createElement('script')

      scriptContainer.src = src.includes('https') ? src : '//' + src
      scriptContainer.type = 'text/javascript'
      scriptContainer.async = true

      appendTo.appendChild(scriptContainer)

      return true
    }
  } catch (e) {
    console.log('error loading script ' + src)
  }
}

const addImagePixel = src => {
  try {
    const imgExists = document.querySelector('img[src*="' + src + '"]')

    if (!imgExists) {
      const imagePixel = document.createElement('img')

      imagePixel.setAttribute('width', '1')
      imagePixel.setAttribute('height', '1')
      imagePixel.setAttribute('style', 'display:none')
      imagePixel.setAttribute('src', '//' + src)

      document.body.appendChild(imagePixel)

      return true
    }
  } catch (e) {
    console.log('error loading pixel ' + src)
  }
}

const CONTACT_ERROR_TYPE_TO_LABEL = {
  unsupportedUsageErrors: 'unsupported-usage',
  exceedOffersPerVIN: 'exceed-offers-vin',
  exceedOffersPerPhoneOrEmail: 'exceed-offers-phone-email',
  offerAlreadyProcessedErrors: 'offer-already-processed-generic'
}

const getOfferErrorEventName = errorOffer => {
  const errorType = ErrorUtils.getErrorType(errorOffer)
  const errorLabel = CONTACT_ERROR_TYPE_TO_LABEL[errorType]
  return errorLabel && `contact_error_${errorLabel}`
}

export { waitUntil, fireDocumentEvent, createGuid, addScript, addImagePixel, getOfferErrorEventName }
